import Group from './Group'
import User from './User'

export default {
  Group,
  User
}



// WEBPACK FOOTER //
// ./src/components/User/index.js